@if (isLoading) {
  <app-tdo-progress-spinner data-cy="referral-match-spinner"></app-tdo-progress-spinner>
}
@if (!isLoading) {
  <div class="section" style="flex: 1; display: flex; flex-direction: column;" data-cy="referral-match-container">
    <div class="section-header" style="flex-basis: fit-content;">
      <div class="section-header-title" data-cy="referral-match-title">{{Title}}</div>
    </div>
    <div class="section-content"
      style="display: block; flex-direction: column; flex: 1; padding: 0px 0px 0px 0px !important;">
      @if (this.data.isReferralDoctor) {
        <div class="main-content-container" data-cy="referral-match-doctor-container">
          @if (!isLoading  && listTDOReferralDoctor) {
            <tdo-table #referralMatchListTable
              [dataSource]="listTDOReferralDoctor" [isSearchable]="true"  [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)"
              style="overflow-y: auto" data-cy="referral-match-doctor-table">
              <tdo-table-column displayName="Name" propertyName="FullName" isSortable="true" [rowTemplate]="FullName">
                <ng-template #FullName let-row>
                  <div style="max-width: 300px;" data-cy="referral-match-doctor-name">
                    {{row.model.FullName}}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Phone" propertyName="primaryPhone" isSortable="true"
                [rowTemplate]="primaryPhone">
                <ng-template #primaryPhone let-row>
                  <div style="max-width: 130px;" data-cy="referral-match-doctor-phone">
                    {{row.model.primaryPhone}}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Email" propertyName="primaryEmail"  isSortable="true" [rowTemplate]="primaryEmail">
                <ng-template #primaryEmail let-row>
                  <div style="max-width: 300px; text-align:justify" data-cy="referral-match-doctor-email">
                    {{row.model.primaryEmail}}
                  </div>
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          }
        </div>
      }
      @if (this.data.isPatient) {
        <div class="main-content-container" data-cy="referral-match-patient-container">
          @if (!isLoading  && listMatchTDOPatients) {
            <tdo-table #referralMatchPatientListTable
              [dataSource]="listMatchTDOPatients" [isSearchable]="false" (rowSelected)="onRowPatientSelected($event)"
              style="overflow-y: auto" data-cy="referral-match-patient-table">
              <tdo-table-column displayName="First Name" propertyName="firstName" isSortable="true"
                [rowTemplate]="firstName">
                <ng-template #firstName let-row>
                  <div style="max-width: 100px;" data-cy="referral-match-patient-firstname">
                    {{row.model.FirstName}}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Mid Name" propertyName="midName" isSortable="true"
                [rowTemplate]="midName">
                <ng-template #midName let-row>
                  <div style="max-width: 180px;" data-cy="referral-match-patient-midname">
                    {{row.model.MidName}}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Last Name" propertyName="lastName" isSortable="true" [rowTemplate]="lastName">
                <ng-template #lastName let-row>
                  <div style="max-width: 160px; text-align: center" data-cy="referral-match-patient-lastname">
                    {{row.model.LastName}}
                  </div>
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          }
        </div>
      }
      @if (this.data.isInsurance) {
        <div class="main-content-container" data-cy="referral-match-insurance-container">
          @if (!isLoading  && listMatchTDOInsurances) {
            <tdo-table #referralMatchInsuranceListTable
              [dataSource]="listMatchTDOInsurances" [isSearchable]="false"
              (rowSelected)="onRowPatientInsuranceSelected($event)"
              style="overflow-y: auto" data-cy="referral-match-insurance-table">
              <tdo-table-column displayName="Insurance NO" propertyName="InsuranceNO" isSortable="true"
                [rowTemplate]="InsuranceNO">
                <ng-template #InsuranceNO let-row>
                  <div style="max-width: 100px;" data-cy="referral-match-insurance-number">
                    {{row.model.PatientInsuranceNO}}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Company Name" propertyName="insuranceCompanyName" isSortable="true"
                [rowTemplate]="insuranceCompanyName">
                <ng-template #insuranceCompanyName let-row>
                  <div style="max-width: 180px;" data-cy="referral-match-insurance-company">
                    {{row.model.dataInsurance.Description}}
                  </div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Coverage End" propertyName="CoverageEnd" isSortable="true"
                [rowTemplate]="CoverageEnd">
                <ng-template #CoverageEnd let-row>
                  <div style="max-width: 160px; text-align: center" data-cy="referral-match-insurance-coverage-end">
                    {{row.model.CoverageEnd | date: 'shortDate'}}
                  </div>
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          }
        </div>
      }
      <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;">
        <div style="flex: 1; margin-right: 6px;"></div>
        <button (click)="onOkAction()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="referral-match-ok-button">OK</button>
        <button (click)="close()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="referral-match-close-button">Close</button>
      </div>
    </div>
  </div>
}
